import clsx from 'clsx';
import { useReframe } from 'nike-re-framejs';
import React, { useRef } from 'react';

import { fireGAEvent } from '@/analytics';
import Switch, { switcher_110_5 } from '@/common/components/Switch';
import i18n from '@i18n';
import ArrowLeftIcon from '@/icons/ArrowLeftIcon';
import WarningIcon from '@/icons/WarningIcon';
import { DialogTitle } from '@/ui/dialogs/Dialog';
import { betslipOpenEditor, betslipToggleQuickbet } from '../handlers';
import { AnimatePresence, motion } from 'framer-motion';

/**
 * @return {null}
 */
export function CollapsedBetslipHeader({ otherClass }) {
    const derefSub = useReframe();
    const sliderRef = useRef();
    const picksCount = derefSub(['betslip/picksCount']);

    if (!picksCount) {
        return null;
    }

    return (
        <AnimatePresence>
            <motion.div
                className="p-fix full-width betslip-header-motion"
                initial={{
                    bottom: -100,
                    opacity: 0
                }}
                style={{ transform: 'translateY(100%))' }}
                animate={{
                    bottom: 0,
                    opacity: 1,
                    transition: {
                        ease: 'easeOut',
                        duration: 0.15
                    }
                }}
                exit={{
                    bottom: -100,
                    opacity: 0,
                    transition: {
                        ease: 'easeInOut',
                        duration: 0.15
                    }
                }}
                key="ticket-collapsed"
            >
                <DialogTitle
                    data-atid="small-ticket-collapsed"
                    className={clsx('betslip-header betslip-header-wrap collapsed', otherClass)}
                    innerRef={sliderRef}
                >
                    <CollapsedBetslip />
                </DialogTitle>
            </motion.div>
        </AnimatePresence>
    );
}

function CollapsedBetslip({ mini }) {
    const derefSub = useReframe();
    const picksCount = derefSub(['betslip/picksCount']);
    const quickbetTriggerability = derefSub(['betslip/quickbet/triggerability']);
    const quickbetActive = derefSub(['betslip/quickbet']);
    const toggleQuickbet = React.useCallback(
        function toggleQuickbet(e) {
            fireGAEvent('Editor tiketu', `Rychle podanie ${quickbetActive ? 'OFF' : 'ON'}`);
            e.stopPropagation();
            betslipToggleQuickbet();
        },
        [quickbetActive]
    );
    const openEditor = () => {
        fireGAEvent('Editor tiketu', 'Otvorit minimalizovany tiket');
        betslipOpenEditor();
    };

    if (!picksCount) {
        return null;
    }

    return (
        <>
            <OrangeBox picksCount={picksCount} betslipWarn={quickbetTriggerability.betslipWarn} onClick={openEditor} />
            {quickbetTriggerability.disabled ? null : (
                <div className="betslip-header-section right">
                    <span className={clsx('betslip-quickbet-text', { white: mini })} onClick={toggleQuickbet}>
                        {i18n('tiket.quickbet')}
                    </span>
                    <Switch
                        switched={quickbetActive}
                        onLeftClick={toggleQuickbet}
                        onRightClick={toggleQuickbet}
                        switcherAnchorStyler={switcher_110_5}
                        disabled={false}
                    />
                </div>
            )}
        </>
    );
}

export function CollapsedBetslipMini() {
    return (
        <div className="betslip-header-wrap flex-center pl-15">
            <CollapsedBetslip mini />
        </div>
    );
}

export function OrangeBox({ picksCount, betslipWarn, onClick, expanded }) {
    const derefSub = useReframe();
    const isSystem = derefSub(['betslip/isSystemBetslip']);
    const totalOdds = derefSub(['betslip/totalOdds']) || 0;
    return (
        <div className="betslip-header-section left" onClick={onClick}>
            <ExpandButton expanded={expanded} />
            <span className="pick-count" data-atid="small-ticket-pick-count">
                {picksCount}
            </span>
            <div className="ticket-small-info">
                {isSystem ? (
                    <span className="system-label">{i18n('jsp.mojeTikety.rozpisovyTiket')}</span>
                ) : (
                    <span className="odds">
                        <span className="odds-label">{i18n('jsp.malyTiket.kurz') + '  '}</span>
                        <span data-atid="small-ticket-total-odds" className="odds-value">
                            {totalOdds}
                        </span>
                    </span>
                )}
            </div>

            {betslipWarn ? (
                <span className="ticket-small-warn">
                    <WarningIcon width={20} height={19} fill={'#fff'} opacity={1} />
                </span>
            ) : null}
        </div>
    );
}

function ExpandButton({ onClick, expanded }) {
    return (
        <button
            data-atid="small-ticket-go-to-action"
            className={clsx('betslip-expand-button', { expanded })}
            type="button"
            onClick={onClick}
        >
            <ArrowLeftIcon width={20} height={20} opacity={1} fill={'#fff'} />
        </button>
    );
}
